export enum ROUTES {
  LAW_FIRMS = 'law-firms',
  CORPORATIONS = 'corporations',
  PORTFOLIOS = 'portfolios',
}
